import { Box, Paper } from "@mui/material";
import Typography from "@mui/material/Typography";
import Input from "../../components/controls/Input";
import useStyles from "./loginStyle";
import { useTranslation } from "react-i18next";
import { useForm, Form } from "../../components/form/useForm";
import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import { login } from "../../redux/reduser/login";

import Button from "../../components/controls/Button";
import globalStyles from "../../style/global.js";
import CircularProgressBar from "../../components/circularProgress/CircularProgress";
import TopAppBar from "../../components/appBar/AppBar";
import ShowActionAlerts from "../../components/dialog/Dialog";
import ShowAlerts from "../../components/alert/Alert";

function Login() {
  const classes = useStyles();
  const globalClasses = globalStyles();
  //let navigate = useNavigate();
  const { response, loading, error, errorMsg } = useSelector(
    (state) => state.login
  );
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const initialFValues = {
    email: "",
    password: "",
  };

  const { t } = useTranslation();

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    if ("password" in fieldValues)
      temp.password = fieldValues.password ? "" : t("required");
    if ("email" in fieldValues)
      temp.email = fieldValues.email
        ? (temp.email = /$^|.+@.+..+/.test(fieldValues.email)
            ? ""
            : t("invalidEmailAddress"))
        : t("required");
    setErrors({
      ...temp,
    });

    if (fieldValues == values) return Object.values(temp).every((x) => x == "");
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, false, validate);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validate()) {
      dispatch(login(values.email, values.response))
        .unwrap()
        .then(() => {
          if (!error) {
            localStorage.setItem("isLogin", "true");
            window.location.reload();

            resetForm();
            setOpen(true);
          } else {
            setOpen(true);
          }
        })
        .catch(() => {
          setOpen(true);
        });
    }
  };

  return (
    <>
      <TopAppBar loginPage={true} color={"transparent"} position={"sticky"} />
      {/* <Box className={classes.settingBox} >

      <Typography variant="h5" color="secondary"> عربي </Typography>
      <Typography variant="h5"  color="secondary">الل،ن </Typography>
      </Box> */}
      <ShowAlerts
        open={open}
        handleClose={handleClose}
        type={error ? "error" : "success"}
        msg={error ? errorMsg : response.toString()}
      />

        <Box>
          {" "}
          <Form onSubmit={handleSubmit} className={classes.form}>
            <Box className={classes.box}>
             <Typography variant="h3" color="primary">{t("welcome")}</Typography>
            </Box>
            <Box className={classes.box}>
              <Input
                name="email"
                label={t("email")}
                className={globalClasses.filed}
                fullWidth={100}
                value={values.email}
                type={"email"}
                onChange={handleInputChange}
                error={errors.email}
              />
            </Box>
            <Box className={classes.box}>
              <Input
                name="password"
                label={t("password")}
                className={globalClasses.filed}
                fullWidth={100}
                type={"password"}
                value={values.password}
                onChange={handleInputChange}
                error={errors.password}
              />
            </Box>

            {loading ? (
              <div className={globalClasses.center}>
                {" "}
                <CircularProgressBar />{" "}
              </div>
            ) : (
              <Box className={classes.btnbox}>
                <Button
                  className={globalClasses.btn}
                  fullWidth="200px"
                  color="primary"
                  disabled={loading}
                  onClick={handleSubmit}
                  text={t("login")}
                />
              </Box>
            )}
          </Form>
        </Box>
  
    </>
  );
}

export default Login;
